import { render, staticRenderFns } from "./YzControlGroup.vue?vue&type=template&id=6d228786&scoped=true&lang=pug&"
import script from "./YzControlGroup.vue?vue&type=script&lang=js&"
export * from "./YzControlGroup.vue?vue&type=script&lang=js&"
import style0 from "./YzControlGroup.vue?vue&type=style&index=0&id=6d228786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d228786",
  null
  
)

export default component.exports